import styled, { css, keyframes } from 'styled-components';
export const sizes = {
    small: '1.125rem',
    medium: '2.25rem',
    large: '6rem',
    'extra-large': '9.75rem',
};
export const Placeholder = styled.div `
  opacity: 0.9;

  ${(props) => !props.square &&
    !props.circle &&
    css `
      width: ${props.width}%;
    `}

  ${(props) => !props.empty &&
    css `
      animation: ${pulse} 1200ms infinite;
      background-color: ${props.theme.colors.grayL20};
    `}

  ${(props) => props.size &&
    css `
      height: ${sizes[props.size] || sizes.small};

      /* Make it square! */
      ${(props.circle || props.square) &&
        css `
        width: ${sizes[props.size] || sizes.small};
      `}
    `}

  ${(props) => props.circle &&
    css `
      border-radius: 50%;
    `}

  /* Spacing between two placeholders */
  & + & {
    margin-top: 0.25rem;
  }
`;
const pulse = keyframes `
  0% {
    opacity: 0.15;
  }
  50% {
    opacity: 0.35;
  }
  100% {
    opacity: 0.15;
  }
`;
//# sourceMappingURL=loading-placeholder.styles.js.map